export const environment = {
  version: 1.0,
  production: true,
  isServer: true,
  // for prerender

  host: 'https://martz.eu',
  cdn: 'https://martz.eu/uploads',
  api: 'https://martz.eu/app',
  socket: 'https://peer.eu',
  base: 'https://martz.eu',
  currencies: ['PLN', 'EUR', 'GBP'],
  withavatar: true,
  name: 'Martz'
};

